/* CustomDateFloatingFilter.jsx */
/* eslint-disable */
import React, { forwardRef, useImperativeHandle, useRef } from "react";
import SearchIcon from "@mui/icons-material/Search";
import "./customDateFloatingFilter.css";

export default forwardRef((props, ref) => {
	const inputRef = useRef(null);
	useImperativeHandle(ref, () => {
		return {
			onParentModelChanged(parentModel) {
				inputRef.current.value = parentModel;
			}
		};
	});

	const onInputBoxChanged = async (input) => {
		props.parentFilterInstance((instance) => {
			setTimeout(() => {
				instance?.componentInstance?.myMethodForTakingValueFromFloatingFilter(input.target.value);
			}, 100);
		});
	};

	const handleSearchButtonClick = () => {
		props.parentFilterInstance((instance) => {
			instance?.componentInstance?.handleSearch();
		});
	};

	const handleHitEnter = (event) => {
		if (event.key === "Enter") {
			props.parentFilterInstance((instance) => {
				console.log("handlehitenter");
				instance?.componentInstance?.handleSearch();
			});
		}
	};

	const style = {
		color: props.color
	};

	return (
		<div className="inputWithSearchFilter">
			<input
				ref={inputRef}
				className="customDateFloatingFilter"
				style={style}
				type="date"
				onInput={onInputBoxChanged}
				onKeyDown={handleHitEnter}
			/>
			<button onClick={handleSearchButtonClick} className="searchButton">
				<span>
					<SearchIcon style={{ fontSize: "18px" }} />
				</span>
			</button>
		</div>
	);
});
